import { addSmartListener } from '../middlewares/listener.middleware';
import { DialogActionsType, resetDialog } from './dialog.actions';

addSmartListener(DialogActionsType.CLOSE)(async (store, _) => {
  setTimeout(() => store.dispatch(resetDialog()), 200);
});
